export const WorkflowName = 'WorkflowComponent';
